import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CountdownComponent } from 'ngx-countdown';
import { Utility } from 'src/app/common/utility';
import { DataService } from 'src/app/services/data.service';
import { StoreService } from 'src/app/services/store.service';
import { ToolsService } from 'src/app/services/tools.service';
import { BaseComponent } from '../base-components/base-component';

@Component({
  selector: 'app-gateway',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.scss']
})
export class GatewayComponent extends BaseComponent implements OnInit {
	@ViewChild('timerModalLink') timerModalLink: ElementRef;
	@ViewChild(CountdownComponent) cd1: CountdownComponent;
	private timeout: any;

  constructor(
		dataService: DataService,
		storeService: StoreService,
		toolsService: ToolsService,
		activatedRoute: ActivatedRoute,
		router: Router
	) {
		super(dataService, storeService, toolsService, activatedRoute, router);
	}

  ngOnInit() {
	this.watchRouteParams();
  }

  gotoScanBarCode(){
		if (this.registerId) {

			if (this.kioskId) {
				this.router.navigate([`/scan/${this.registerId}/${this.kioskId}`]);
			} else {
				this.router.navigate([`/scan/${this.registerId}`]);
			}

		}
	}

	gotoRegister(){
		if (this.registerId) {

			if (this.kioskId) {
				this.router.navigate([`/register/${this.registerId}/${this.kioskId}`]);
			} else {
				this.router.navigate([`/register/${this.registerId}`]);
			}

		}

	}
	onNotify(event) {
		const self = this;

		if (event === 15000) {
			self.timerModalLink.nativeElement.click();
		} else if (event === 1000) {
			self.timeout = setTimeout(async () => {
				self.timerModalLink.nativeElement.click();
				await self.cancelOrder();
			}, 1000);
		}
	}

	cancelTimeout() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
	}

	@HostListener('click', ['$event.target']) onClick(ctrl) {
		// don't reset the timer why we programmatically click the link to show/hide the timer dialog
		if (ctrl.dataset.target !== '#timer-modal') {
			this.cd1.restart();
		}
	}

	@HostListener('keydown') onKeyDown() {
		this.cd1.restart();
	}

	 async cancelOrder() {
		const self = this;
        await Utility.clearSessionCart(self.storeService,self.dataService,self.toolsService);
		if (self.registerId) {
			if (self.kioskId) {
				self.router.navigate([`/dashboard/${self.registerId}/${self.kioskId}`]);
			} else {
				self.router.navigate([`/dashboard/${self.registerId}`]);
			}
		}
	}

}
